export default (state = "", action) => {
  if (action.type === "INPUT_PASSWORD") {
    return action.payload;
  }
  return state;
};
